(function () {
  function getGalleryData(sectionId, variantId) {
    const el = document.getElementById(`VariantGalleryData-${sectionId}`);
    if (!el) return null;

    const data = JSON.parse(el.textContent);
    return data[variantId]?.gallery || null;
  }

  function getSelectedVariantId(productInfo) {
    const input = productInfo.querySelector('input[name="id"]');
    return input ? input.value : null;
  }

  function init() {
    const productInfo = document.querySelector('product-info');
    if (!productInfo) return;

    const mediaGallery = productInfo.querySelector('media-gallery');
    if (!mediaGallery) return;

    const list = mediaGallery.querySelector('.product__media-list');
    if (!list) return;

    // Save original slide as template (once)
    const templateSlide = list.querySelector('.product__media-item');
    if (!templateSlide) return;

    function updateGallery() {
        requestAnimationFrame(() => {
            const variantId = getSelectedVariantId(productInfo);
            if (!variantId) return;

            const sectionId = productInfo.dataset.section;
            const galleryData = getGalleryData(sectionId, variantId);
            if (!galleryData?.length) return;

            // Clear existing slides
            list.innerHTML = '';

            galleryData.forEach((media, index) => {
            if (!media?.src) return;

            const slide = templateSlide.cloneNode(true);

            slide.classList.add('slider__slide', 'grid__item');
            slide.dataset.mediaId = `variant-${variantId}-${index}`;

            const img = slide.querySelector('img');
            if (!img) return;

            img.src = media.src;
            img.srcset = '';
            img.sizes = '100vw';
            img.alt = media.alt || '';
            img.loading = 'lazy';

            const container = slide.querySelector('.product-media-container');
            if (container) {
                container.style.setProperty('--ratio', '1');
                container.style.setProperty('--preview-ratio', '1');
            }

            list.appendChild(slide);
            });

            mediaGallery.dispatchEvent(new CustomEvent('media:refresh'));

            list.querySelectorAll('.scroll-trigger').forEach(el => {
                el.classList.remove('scroll-trigger', 'scroll-trigger--offscreen');
                el.style.opacity = '1';
            });
        });
    }
    productInfo.addEventListener('change', updateGallery);

    updateGallery();
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();
})();